import BaseService from '@/api/services/BaseService';

const API_RESOURCE = {
  BASE: 'sms/group',
  CURRENT_USER: 'sms/group/user',
  ENTERPRISE: 'sms/group/account'
}

export default class GroupService extends BaseService {
  static upsertUserGroup(group) {
    const URI = `${API_RESOURCE.BASE}`;
    const config = { headers: { 'include-children': true } };
    return this.postRequest(URI, group, config);
  }

  static deleteUserGroup(groupId) {
    const URI = `${API_RESOURCE.BASE}/${groupId}`;
    return this.deleteRequest(URI);
  }

  static removeContactFromUserGroup(groupId, contactId) {
    const URI = `${API_RESOURCE.BASE}/${groupId}/${contactId}`;
    const config = { headers: { 'include-children': true } };
    return this.deleteRequest(URI, config);
  }

  static getUserGroups() {
    const URI = `${API_RESOURCE.CURRENT_USER}/${this.encodedUserId}`;
    const config = { headers: { 'include-children': true } };
    return this.getRequest(URI, config);
  }

  static getEnterpriseGroups() {
    const URI = `${API_RESOURCE.ENTERPRISE}/${this.encodedEnterpriseId}`;
    const config = { headers: { 'include-children': true } };
    return this.getRequest(URI, config);
  }
}
